import Body from './Body';
import Header from './Header';

const ProductItem = {
  Header,
  Body,
};

export default ProductItem;
